'use strict'

var normalize = require('mdurl/encode')
var all = require('../all')

module.exports = link

/* Transform a link. */
function link(h, node) {
  var props = {href: normalize(node.url)}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'a', props, all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/link.js
// module id = 222
// module chunks = 94053359063892 107818501498521